'use client';

/*
Contact — mise en page alignée sur la homepage v5.
*/
import Head from '@/core/head';
import Icon from '@/core/icon.js';
import { lang, hocT } from '@/helpers/translate';
import { getCanonicalUrl } from '@/helpers/router.js';
import { FadeUp, Stagger, StaggerChild } from '@/core/motion';
import {
  SECTION, CARD, BTN_PRIMARY, Kicker, ArrowIcon, kicker,
} from '@/core/editorial';

export default hocT(({ t }) => {
  const langCurrent = lang();
  const canurls = getCanonicalUrl('contact', langCurrent);

  const channels = [
    {
      key: 'chat',
icon: 'chat',
title: t('contact:chat'),
desc: t('contact:chat_desc'),
hour: t('contact:chat_hour'),
      action: <button type="button" className={BTN_PRIMARY} onClick={() => window?.Intercom('show', 'acwgt8bk')}>{t('contact:chat_link')}<ArrowIcon /></button>,
    },
    {
      key: 'email',
icon: 'email',
title: t('contact:email'),
desc: t('contact:email_desc'),
hour: '',
      action: <a href={`mailto:${t('contact:email_email')}`} className={BTN_PRIMARY}>{t('contact:email_email')}<ArrowIcon /></a>,
    },
    {
      key: 'phone',
icon: 'tel',
title: t('contact:phone'),
desc: t('contact:phone_desc_2'),
hour: t('contact:phone_hour'),
      action: <a href="tel:+33159134277" className={`${BTN_PRIMARY} whitespace-nowrap`}>+33 1 59 13 42 77<ArrowIcon /></a>,
    },
  ];

  return (
    <div className="bg-white font-display text-was-ink">
      <Head>
        {canurls.map((cprops) => <link key={JSON.stringify(cprops)} {...cprops} />)}
      </Head>
      <section className="bg-white">
        <div className={`${SECTION} pt-28 lg:pt-36`}>
          <FadeUp>
            <Kicker n="01">{kicker(langCurrent, 'contact', 0)}</Kicker>
            <h1 className="mt-5 max-w-[820px] text-balance font-heading text-[32px] font-extrabold uppercase leading-[1.04] tracking-[-0.01em] md:text-[40px] lg:text-[46px]">{t('contact:title')}</h1>
            <p className="mt-6 max-w-[620px] text-lg leading-relaxed text-was-slate">
              {t('contact:subtitle')}
              {' '}
              <a href={`${process.env.NEXT_PUBLIC_URL_V4}/help`} className="text-was-ink underline decoration-was-ink/30 underline-offset-4 hover:decoration-was-ink" target="_blank" rel="noreferrer">{t('contact:subtitle_link')}</a>
              .
            </p>
          </FadeUp>
          <Stagger stagger={0.1} delay={0.1} className="mt-12 grid gap-6 md:grid-cols-3 lg:mt-16">
            {channels.map((c) => (
              <StaggerChild key={c.key} className={`flex flex-col p-7 lg:p-8 ${CARD}`}>
                <div className="flex items-center gap-3">
                  <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-was-ink text-white"><Icon name={c.icon} className="size-5 fill-current" /></span>
                  <h2 className="m-0 text-[20px] font-bold leading-tight tracking-[-0.02em]">{c.title}</h2>
                </div>
                <p className="m-0 mt-5 text-[15px] leading-relaxed text-was-slate">{c.desc}</p>
                {c.hour && <p className="m-0 mt-3 text-[13px] text-was-muted">{c.hour}</p>}
                <div className="mt-auto pt-7">{c.action}</div>
              </StaggerChild>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
});
